import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const quillDocumentImageApi = {
    getQuillDocumentImageById: (id: number): Observable<Dtos.GetQuillDocumentImageByIdResponse> => {
        //Create the request.
        let request: Dtos.GetQuillDocumentImageById = new Dtos.GetQuillDocumentImageById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetQuillDocumentImageByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getQuillDocumentImageByQuillDocumentId: (quillDocumentId: number): Observable<Dtos.GetQuillDocumentImageByQuillDocumentIdResponse> => {
        //Create the request.
        let request: Dtos.GetQuillDocumentImageByQuillDocumentId = new Dtos.GetQuillDocumentImageByQuillDocumentId();

        request.quillDocumentId = quillDocumentId;

        //Send request.
        const response: Promise<Dtos.GetQuillDocumentImageByQuillDocumentIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setQuillDocumentImage: (quillDocumentImage: Dtos.QuillDocumentImage): Observable<Dtos.SetQuillDocumentImageResponse> => {

        let request: Dtos.SetQuillDocumentImage = new Dtos.SetQuillDocumentImage();

        request.quillDocumentImage = quillDocumentImage;

        // send request
        const response: Promise<Dtos.SetQuillDocumentImageResponse> = client.post(request);

        return Observable.from(response);

    },
    createQuillDocumentImage: (quillDocumentId: number): Observable<Dtos.CreateQuillDocumentImageResponse> => {
        //Create the request.
        let request: Dtos.CreateQuillDocumentImage = new Dtos.CreateQuillDocumentImage();

        request.quillDocumentId = quillDocumentId;

        //Send request.
        const response: Promise<Dtos.CreateQuillDocumentImageResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}